module.exports = __webpack_public_path__ + "static/media/image-campaign-donate-heart.36985135.png";